import { BEGIN_LOADING_SESSION_INFO, BEGIN_LOG_IN, BEGIN_REGISTER, BEGIN_REQUEST_HUMAN_STATUS, BEGIN_REQUEST_RESET_PASSWORD, ERROR_LOG_IN, ERROR_REGISTER, ERROR_REQUEST_HUMAN_STATUS, ERROR_REQUEST_RESET_PASSWORD, ERROR_SESSION_INFO, LOGGED_OUT, MAYBE_LOG_OUT, RECEIVE_SESSION_INFO, SUCCESS_LOG_IN, SUCCESS_REGISTER, SUCCESS_REQUEST_HUMAN_STATUS, SUCCESS_REQUEST_RESET_PASSWORD } from "./actionTypes.mjs";
import { fromJS } from "immutable";
//#region src/store/session/reducer.ts
var initialState = fromJS({
	info: {},
	infoError: void 0,
	infoIsLoaded: false,
	infoIsLoading: true,
	loginRequestStatus: {
		error: void 0,
		isLoading: false
	},
	humanStatusRequestStatus: {
		error: void 0,
		isLoading: false
	},
	registrationRequestStatus: {
		error: void 0,
		isLoading: false
	},
	resetPasswordRequestStatus: {
		error: void 0,
		isLoading: false
	},
	serverLoginRedirect: void 0,
	email: "",
	hasGeneratedPassword: void 0
});
function reducer(state = initialState, action) {
	switch (action.type) {
		case BEGIN_LOADING_SESSION_INFO: return state.merge({
			infoError: void 0,
			infoIsLoading: true
		});
		case RECEIVE_SESSION_INFO: return state.merge({
			info: fromJS(action.payload.info),
			infoError: void 0,
			infoIsLoaded: true,
			infoIsLoading: false
		});
		case ERROR_SESSION_INFO: return state.merge({
			infoError: action.payload.error,
			infoIsLoading: false
		});
		case BEGIN_LOG_IN: return state.merge({ loginRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case SUCCESS_LOG_IN: return state.merge({
			loginRequestStatus: {
				error: void 0,
				isLoading: false
			},
			serverLoginRedirect: action.payload.serverLoginRedirect
		});
		case ERROR_LOG_IN: return state.merge({ loginRequestStatus: {
			error: action.payload.error,
			statusCode: action.payload.statusCode,
			isLoading: false
		} });
		case BEGIN_REQUEST_HUMAN_STATUS: return state.merge({ humanStatusRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case SUCCESS_REQUEST_HUMAN_STATUS: return state.merge({
			humanStatusRequestStatus: {
				error: void 0,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: action.payload.hasGeneratedPassword,
			isNewHuman: action.payload.isNewHuman
		});
		case ERROR_REQUEST_HUMAN_STATUS: return state.merge({
			humanStatusRequestStatus: {
				error: action.payload.error,
				statusCode: action.payload.statusCode,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: false
		});
		case BEGIN_REQUEST_RESET_PASSWORD: return state.merge({ resetPasswordRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case SUCCESS_REQUEST_RESET_PASSWORD: return state.merge({
			resetPasswordRequestStatus: {
				error: void 0,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: action.payload.hasGeneratedPassword,
			isNewHuman: action.payload.isNewHuman
		});
		case ERROR_REQUEST_RESET_PASSWORD: return state.merge({
			resetPasswordRequestStatus: {
				error: action.payload.error,
				statusCode: action.payload.statusCode,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: false
		});
		case BEGIN_REGISTER: return state.merge({ registrationRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case SUCCESS_REGISTER: return state.merge({
			registrationRequestStatus: {
				error: void 0,
				isLoading: false,
				success: true
			},
			serverLoginRedirect: action.payload.serverLoginRedirect
		});
		case ERROR_REGISTER: return state.merge({ registrationRequestStatus: {
			error: action.payload.error,
			isLoading: false
		} });
		case MAYBE_LOG_OUT: return state.merge({ infoIsLoading: true });
		case LOGGED_OUT: return state.merge({
			info: { logged_in: false },
			infoError: void 0,
			infoIsLoaded: true,
			infoIsLoading: false
		});
		default: return state;
	}
}
//#endregion
export { reducer as default, initialState };

//# sourceMappingURL=reducer.mjs.map